import { Component, OnInit, Renderer2, ViewChild, ElementRef, Directive, ChangeDetectorRef, DestroyRef, inject, SecurityContext } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from '../.././security/auth.service';
import { Router, ActivatedRoute, NavigationEnd, NavigationStart, RouterLink, RouterLinkActive } from '@angular/router';
import { BehaviorSubject, firstValueFrom, Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Location, LocationStrategy, PathLocationStrategy, NgClass, NgIf, NgFor, SlicePipe } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { Menu } from '../.././shared/model/security/menu.model';
import { Constantes } from 'src/app/utilerias/constantes/constantes';
import { UrlConstantes } from 'src/app/utilerias/constantes/urlconstantes';
import { IncidenciasService } from 'src/app/incidencias/incidencias.service';
import { Global } from 'src/app/utilerias/global';
import { NotificacionUsuario } from '../model/incidencias/notificacionUsuario.model';
import { ComunicacionService } from '../services/comunicacion.service';
import swal from 'sweetalert2';
import { rutaDeMenu } from '../menu/ruta-menu';
import { SelectorTemaComponent } from '../tema/selector-tema.component';
import { esUsuarioCliente } from '../../security/portal-cliente.guard';
const misc: any = {
    navbar_menu_visible: 0,
    active_collapse: true,
    disabled_collapse_init: 0,
};

declare var $: any;
@Component({
    selector: 'app-navbar-cmp',
    templateUrl: 'navbar.component.html',
    styleUrls: ['navbar.component.scss'],
    imports: [NgClass, NgIf, RouterLink, RouterLinkActive, NgFor, SlicePipe, SelectorTemaComponent]
})

export class NavbarComponent implements OnInit {
    location: Location;
    mobile_menu_visible: any = 0;

    private sidebarVisible: boolean;

    notificaciones: NotificacionUsuario[];
    nuevas: number;
    pNombre:string = '';
    fotosidebar: any = './assets/img/default-avatar.png';
    
    @ViewChild('app-navbar-cmp', {static: false}) button: any;

    // La vista NO se repinta sola cuando llega una respuesta HTTP (zone.js no
    // queda parcheando nada en este arranque): el avatar pide su repintado.
    private readonly cdr = inject(ChangeDetectorRef);
    private readonly destroyRef = inject(DestroyRef);
    /** true desde que el navbar se destruye; guarda el repintado (ver repintar()). */
    private destruido = false;

    constructor(location: Location, private element: ElementRef, 
     private authService: AuthService, private incidenciasService: IncidenciasService,
      private comunicacion: ComunicacionService,
      private globals: Global,
      private router: Router,
      private sanitizer: DomSanitizer
    ) {
        this.location = location;
   
        this.sidebarVisible = false;
        this.nuevas = 0;
        this.destroyRef.onDestroy(() => (this.destruido = true));
    }
    minimizeSidebar(){
      const body = document.getElementsByTagName('body')[0];

      if (misc.sidebar_mini_active === true) {
          body.classList.remove('sidebar-mini');
          misc.sidebar_mini_active = false;
      } else {
          setTimeout(function() {
              body.classList.add('sidebar-mini');

              misc.sidebar_mini_active = true;
          }, 300);
      }


      // we simulate the window Resize so the charts will get updated in realtime.
      const simulateWindowResize = setInterval(function() {
          window.dispatchEvent(new Event('resize'));
      }, 180);

      // we stop the simulation of Window Resize after the animations are completed
      setTimeout(function() {
          clearInterval(simulateWindowResize);
      }, 1000);
    }
    hideSidebar(){
      const body = document.getElementsByTagName('body')[0];
      const sidebar = document.getElementsByClassName('sidebar')[0];

      if (misc.hide_sidebar_active === true) {
          setTimeout(function() {
              body.classList.remove('hide-sidebar');
              misc.hide_sidebar_active = false;
          }, 300);
          setTimeout(function () {
              sidebar.classList.remove('animation');
          }, 600);
          sidebar.classList.add('animation');

      } else {
          setTimeout(function() {
            body.classList.add('hide-sidebar');
            
            misc.hide_sidebar_active = true;
          }, 300);
      }

     
      const simulateWindowResize = setInterval(function() {
          window.dispatchEvent(new Event('resize'));
      }, 180);

      // we stop the simulation of Window Resize after the animations are completed
      setTimeout(function() {
          clearInterval(simulateWindowResize);
      }, 1000);
    }

    ngOnInit() {
        const navbar: HTMLElement = this.element.nativeElement;
        const body = document.getElementsByTagName('body')[0];
     
        if (body.classList.contains('sidebar-mini')) {
            misc.sidebar_mini_active = true;
        }
        if (body.classList.contains('hide-sidebar')) {
            misc.hide_sidebar_active = true;
        }
      
        this.consultaNotificaciones();
        this.persona();
        // La foto que se acaba de guardar en Ajustes. El valor inicial es "" y
        // no se pinta: dejaba el avatar en blanco mientras llegaba el del servidor.
        this.authService.customFotoPerfilUser
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(foto => {
                if (foto) {
                    this.fotosidebar = foto;
                    this.repintar();
                }
            });

        this.comunicacion.notificar.subscribe(notificar => {
            if (notificar !== null && notificar !== undefined) {
                this.agregarNotificacion(notificar);
            }
        });

        this.comunicacion.obtenerNuevas.subscribe(nuevas => {
            if (nuevas) {
                this.consultaNotificaciones();
            }
        });

        this.comunicacion.elimina.subscribe(eliminada => {
            if (null !== eliminada && undefined !== eliminada) {
                this.consultaNotificaciones();
            }
        });
        
    }
    
     public marcarVistoTodas() {
        firstValueFrom(this.incidenciasService.marcarVistoTodas(this.notificaciones)).then(() => {
                this.consultaNotificaciones();
            }).catch(() => { });
    }

    private consultaNotificaciones() {
        // El portal de clientes no tiene notificaciones (son del personal:
        // van por la ficha de empleado) y el servidor le niega el endpoint.
        if (esUsuarioCliente(this.authService)) {
            this.notificaciones = [];
            this.nuevas = 0;
            return;
        }
        this.incidenciasService.obtenerElementoPorCampo(UrlConstantes.OBTENER_NOTIFICACION_USUARIO, Constantes.VACIO).
            subscribe(res => {
                if (this.validarcodigoErrorLista(res)) {
                    // this.globals.notificaciones = res;
                    this.notificaciones = res.sort((a, b) => new Date(b.fechaCreacion).getTime() - new Date(a.fechaCreacion).getTime())
                  
                    this.obtenerNoLeidas();
                } else {
                    // this.globals.notificaciones = res;
                    this.notificaciones = res;
                    this.nuevas = 0;
                }
            });
    }

    /**
     * @param lista Valida el codigo de error de la lista
     */
    public validarcodigoErrorLista(lista: any[]): boolean {
        if (lista == null || lista === undefined) {
            return false;
        }
        if (lista.length <= Constantes.CERO) {
            return false;
        }
        const numero = this.convertirANumero(lista[Constantes.CERO].pCodRetorno);
        if (numero < Constantes.CERO || numero > Constantes.CERO) {
            return false;
        }
        return true;
    }
       
    /**
        * Método que convierte a número la cadena proporcionada, si ocurre un error regesa -1
        * @param valor // Cadena
        */
    convertirANumero(valor: string): number {
        if (valor != null && valor !== undefined && valor.trim() !== Constantes.VACIO) {

            try {
                const numero = Number(valor);
                return !Number.isNaN(numero) ? numero : -1;
            } catch (e) {
                return -1;
            }

        } else {
            return -1;
        }
    }
     
    onResize(event) {
      if ($(window).width() > 991) {
        return false;
      }
      return true;
    }

    toggleSidebarFromButton() {
      if ($(window).width() > 991) {
        this.minimizeSidebar();
        return;
      }
      this.sidebarToggle();
    }

    private getSidebarToggleButton(): Element | undefined {
      return document.getElementsByClassName('navbar-toggler')[0]
        || document.getElementsByClassName('navbar-sidebar-toggle')[0];
    }

    sidebarOpen() {
      var $toggle = this.getSidebarToggleButton();
   
        const body = document.getElementsByTagName('body')[0];

        body.classList.add('nav-open');
        setTimeout(function() {
            $toggle?.classList.add('toggled');
        }, 430);

        var $layer = document.createElement('div');
        $layer.setAttribute('class', 'close-layer');


        if (body.querySelectorAll('.main-panel')) {
            document.getElementsByClassName('main-panel')[0].appendChild($layer);
        }else if (body.classList.contains('off-canvas-sidebar')) {
            document.getElementsByClassName('wrapper-full-page')[0].appendChild($layer);
        }

        setTimeout(function() {
            $layer.classList.add('visible');
        }, 100);

        $layer.onclick = function() { //asign a function
          body.classList.remove('nav-open');
          this.mobile_menu_visible = 0;
          this.sidebarVisible = false;

          $layer.classList.remove('visible');
          setTimeout(function() {
              $layer.remove();
              $toggle?.classList.remove('toggled');
          }, 400);
        }.bind(this);

        body.classList.add('nav-open');
        this.mobile_menu_visible = 1;
        this.sidebarVisible = true;
    };
   
    sidebarClose() {
      var $toggle = this.getSidebarToggleButton();
        const body = document.getElementsByTagName('body')[0];
     
        const layers = Array.from(document.getElementsByClassName('close-layer'));

        this.sidebarVisible = false;
        body.classList.remove('nav-open');

        body.classList.remove('nav-open');
        layers.forEach((layer) => layer.remove());

        setTimeout(function() {
            $toggle?.classList.remove('toggled');
        }, 400);

        this.mobile_menu_visible = 0;
    };
    
    sidebarToggle() {
        if (this.sidebarVisible === false) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
    }

    /**
     * Titulo de la pagina para la navbar.
     *
     * El de antes comparaba la URL con "padre/hijo" armado a mano y con
     * la barra inicial puesta, asi que casi nunca coincidia y se quedaba
     * en "Inicio" en todas las pantallas. Ahora se aplana el menu con la
     * misma regla con la que el sidebar arma sus enlaces (rutaDeMenu: la
     * hoja puede traer `ruta` propia) y gana la entrada cuya ruta sea el
     * prefijo mas largo de la URL actual, por segmentos completos: asi
     * /TICKETS/DetalleTickets/2556 cae en "Atencion Tickets" aunque el
     * detalle no este en el menu. El menu se vuelve a leer cuando cambia
     * (menuCambiado), no solo al arrancar.
     */
    getTitle(): string {
      let actual = this.location.prepareExternalUrl(this.location.path());
      if (actual.charAt(0) === '#') {
        actual = actual.slice(1);
      }
      // Sin diagonales en los extremos; la cola arranca tras un caracter que no es diagonal ($1 lo devuelve).
      actual = actual.split('?')[0].replace(/^\/+|([^/])\/+$/g, '$1').toLowerCase();
      if (!actual || actual === 'dashboard') {
        return 'Inicio';
      }

      let mejor: { ruta: string; nombre: string } | null = null;
      for (const entrada of this.rutasDelMenu()) {
        const coincide = actual === entrada.ruta || actual.startsWith(entrada.ruta + '/');
        if (coincide && (!mejor || entrada.ruta.length > mejor.ruta.length)) {
          mejor = entrada;
        }
      }
      if (mejor) {
        return mejor.nombre;
      }
      // Fuera del menu (detalles, altas): el ultimo segmento legible.
      const segmentos = actual.split('/').filter((s) => s && !/^\d+$/.test(s));
      const ultimo = segmentos[segmentos.length - 1] || 'Inicio';
      return ultimo.replace(/[-_]+/g, ' ').replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, (c) => c.toUpperCase());
    }

    /** El menu aplanado: cada hoja con la ruta completa que usa el sidebar. */
    private rutasDelMenu(): Array<{ ruta: string; nombre: string }> {
      const menus: Menu[] = this.authService.getMenuList() || [];
      const salida: Array<{ ruta: string; nombre: string }> = [];
      const agregar = (item: Menu, padre?: Menu) => {
        if (!item) {
          return;
        }
        if (item.tipo === 'link') {
          const ruta = rutaDeMenu(item, padre).slice(1).join('/').toLowerCase();
          if (ruta) {
            salida.push({ ruta, nombre: item.nombre });
          }
        }
        (item.hijos || []).forEach((hijo) => agregar(hijo, item));
      };
      menus.forEach((m) => agregar(m));
      return salida;
    }
    getPath() {
        return this.location.prepareExternalUrl(this.location.path());
    }
    logout() {
        swal.fire({
            text: '¿Desea cerrar sesión?',
            icon: 'warning',
            showCancelButton: true,
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger',
            },
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
            buttonsStyling: false
        }).then((result) => {
            if (result.value) {
                this.authService.logout();
                this.globals.pauseTimer();
            }
        });
    }

    abrePantalla() {
        this.router.navigate(['admin/ajustes']);
    }

    persona() {
        this.authService.getSesion().subscribe(res => {
            const nombre = res.persona.nombre.split(' ', 1)[0].concat(' ').concat(res.persona.apellidoPaterno);

            setTimeout(() => {
                this.pNombre = nombre;
            }, 0);
            try {
                localStorage.setItem('CosData', JSON.stringify(res));
                this.authService.consultpersonfoto(0).subscribe((foto: any) => {
                    let imgtxt = '';
                    (new Uint8Array(foto)).forEach((byte: number) => {
                        imgtxt += String.fromCodePoint(byte);
                    });
                    // Por el saneador de Angular, no saltándolo: con el prefijo data:image fijo la deja pasar tal cual.
                    this.fotosidebar = this.sanitizer.sanitize(SecurityContext.URL, 'data:image/jpg;base64,' + btoa(imgtxt));
                    this.repintar();
                }, () => {
                    this.fotosidebar = './assets/img/default-avatar.png';
                    this.repintar();
                });
            } catch (error) {
                console.log(error);
                this.fotosidebar = './assets/img/default-avatar.png';
            }
        });
    }

    private repintar() {
        if (!this.destruido) {
            this.cdr.markForCheck();
            this.cdr.detectChanges();
        }
    }

    agregarNotificacion(notificaction: NotificacionUsuario) {
        if (notificaction != null && notificaction !== undefined) {
            if (notificaction.descripcion !== null && notificaction.descripcion !== undefined) {
                this.notificaciones.unshift(notificaction);
                this.obtenerNoLeidas();
            }
        }
    }

    marcarVisto(idNotificacion: number) {
        this.notificaciones = this.notificaciones.filter(n => n.id !== idNotificacion);
        // this.notificaciones = this.globals.notificaciones.filter(n => n.id !== idNotificacion);
        this.marcarVistoNotificacion(idNotificacion);
    }

    private marcarVistoNotificacion(idNotificacion: number) { 
        firstValueFrom(this.incidenciasService.marcarVistoNotificacion({ 'id': idNotificacion })).then(() => {
                this.obtenerNoLeidas();
            }).catch(() => { });
    }

    private obtenerNoLeidas() {
        const noLeidas = this.notificaciones.filter(d => d.revisado === false);
        this.nuevas = noLeidas !== null && noLeidas !== undefined ? noLeidas.length : 0;   
    }
}
